import React from 'react'
import {Link} from 'react-router-dom'
import PropTypes from 'prop-types'
import ReactMarkdown from 'react-markdown'
import Caption from '../Caption'
import Button from '../Button'
import Col from "../Col"
import Container from "../Container"
import './article.sass'

const Article = ({posts}) => {
  if (!posts){
    return null
  }
  return (
    <section className="news-wrapper">
      <Container>
        <Col xs={6} sm={12} md={24} lg={24}>
          <Caption>{posts.caption}</Caption>
          <Link to='/posts' className="titleWrapper">
            <Button bsStyle='arrow-left' bsSize="lg">Все новости</Button>
          </Link>
          <ReactMarkdown source={posts.text} className="article" escapeHtml={false} />
        </Col>
      </Container>
    </section>
  )
}

Article.propTypes = {
  posts: PropTypes.shape({
    caption: PropTypes.string,
    text: PropTypes.string
  }).isRequired
}

export default Article





// WEBPACK FOOTER //
// ./components/NewsArticle/index.jsx